var optionalExtrasMixin = {
	data: function () {
		return {
			showOptionalExtras: false,
		};
	},
	mounted() {
		const vm = this;
		vm.countOptions();
	},
	methods: {
		/**
		 * Loads a default value if specified in the backend
		 */
		countOptions: function () {
			const options = document.querySelectorAll('.optional-extra-block .optional-single:not(.weight)');
			if (options.length > 0) {
				const vm = this;
				vm.showOptionalExtras = true;
			}
		},
		/**
		 * Clears the data from the optional extras and updates the price
		 * @param {string} id - element that has been clicked
		 */
		clearOptionalExtras: function (id) {
			const vm = this;

			switch (id) {
				case 'edge-finishing':
					vm.product.edgeFinishing = 0;
					break;
				case 'round-corners':
					vm.product.roundedCorners = {
						bottomLeftRadius: 0,
						bottomRightRadius: 0,
						topLeftRadius: 0,
						topRightRadius: 0,
					};
					break;
				case 'drilled-holes':
					vm.product.holes = vm.defaultDrilledHoles();
					vm.$refs['drilled-holes-error'].classList.add('d-none');
					vm.$refs['countersink-2-label'].click();
					vm.$refs['drill-hole-size'].required = false;
					vm.$refs['drill-hole-distance'].required = false;

					const drillHoles = document.querySelectorAll('input[name="drill-hole"]');
					drillHoles.forEach(function (drillHole) {
						drillHole.required = false;
					});

					const checkBoxes = document.querySelectorAll('.drill-hole-wrapper input:checked');
					checkBoxes.forEach(function (checkBox) {
						checkBox.checked = false;
					});

					const invalidFields = document.querySelectorAll('#drilled-holes .is-invalid');
					invalidFields.forEach(function (invalidField) {
						invalidField.classList.remove('is-invalid');
						invalidField.parentElement.classList.remove('is-invalid');
					});

					const errorMessages = document.querySelectorAll("#drilled-holes [id$='-error']");

					vm.clearServerSideErrors(errorMessages);

					vm.updateProductPrice();

					break;
				case 'additional-instructions':
					vm.product.additionalInstructions = '';
					break;
				default:
			}

			switch (id) {
				case 'edge-finishing': 
				case 'round-corners':
				case 'drilled-holes':
					vm.updateProductPrice();
					break;
				default:
			}
		},
		openOptionalExtras: function (id) {
			const vm = this;
			switch (id) {
				case 'drilled-holes':
					//add required to all fields 
					vm.$refs['drill-hole-size'].required = true;
					vm.$refs['drill-hole-distance'].required = true;
					vm.product.holes.hasDrilledHoles = true;
					const drillHoles = document.querySelectorAll('input[name="drill-hole"]');
					drillHoles.forEach(function (drillHole) {
						drillHole.required = true;
					});

					break;
				default:
			}
		},
		pricePer: function (property, incVat) {
			let thickness = vueProduct.product.dimensions.thickness;
			if (thickness > 0) {
				this.from = "";
			}
			else {
				thickness = 1
			}

			const item = vueProduct_DATA.optionalExtrasPricePer.find(item => item.thickness === thickness);

			if (!item) return null; 

			return incVat ? item[property].formattedPriceIncVat : item[property].formattedPriceExVat;
		}
	},
};
